import { render, staticRenderFns } from "./ClientPasswordForm.vue?vue&type=template&id=779a88fa&scoped=true&"
import script from "./ClientPasswordForm.vue?vue&type=script&lang=js&"
export * from "./ClientPasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779a88fa",
  null
  
)

export default component.exports